import React from 'react';
import { Navigate } from 'react-router-dom';
import SentryTest from '../../components/SentryTest';
import { SentryErrorBoundary } from '../../utils/sentryErrorBoundary';

const SentryTestPage: React.FC = () => {
  // Rediriger vers la page d'accueil si on est en production
  if (process.env.REACT_APP_MODE === 'PROD') {
    return <Navigate to="/" replace />;
  }

  return (
    <SentryErrorBoundary>
      <div style={{ 
        padding: '20px',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh'
      }}>
        <h1 style={{ 
          color: '#333',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          🧪 Page de Test Sentry
        </h1>
        
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <SentryTest />
          
          <div style={{
            marginTop: '30px',
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '1px solid #dee2e6'
          }}>
            <h3>📖 Guide d'utilisation</h3>
            <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
              <p><strong>🌍 Test Environnement :</strong> Affiche les informations sur l'environnement actuel et la configuration Sentry.</p>
              <p><strong>❌ Test Erreur :</strong> Génère une erreur JavaScript pour tester la capture d'exceptions.</p>
              <p><strong>💬 Test Message :</strong> Envoie un message informatif à Sentry.</p>
              <p><strong>🍞 Test Breadcrumb :</strong> Ajoute un breadcrumb puis envoie un message pour tester le contexte.</p>
              <p><strong>👤 Test Utilisateur :</strong> Définit un contexte utilisateur et envoie un message.</p>
              <p><strong>🏷️ Test Tags :</strong> Ajoute des tags personnalisés et envoie un message.</p>
              <p><strong>🗑️ Effacer :</strong> Vide la liste des résultats des tests.</p>
            </div>
          </div>

          <div style={{
            marginTop: '20px',
            padding: '20px',
            backgroundColor: '#fff3cd',
            borderRadius: '8px',
            border: '1px solid #ffeaa7'
          }}>
            <h4 style={{ color: '#856404', margin: '0 0 10px 0' }}>⚠️ Important</h4>
            <p style={{ margin: 0, fontSize: '14px', color: '#856404' }}>
              Cette page est uniquement destinée aux tests de développement. 
              En production, l'accès à cette page est automatiquement désactivé.
            </p>
          </div>
        </div>
      </div>
    </SentryErrorBoundary>
  );
};

export default SentryTestPage;
